import { Grid } from "@material-ui/core";
import React from "react";

interface Props {
    property: string;
    value: string;
    onClick?: () => void;
}

export function DetailRow(props:Props){
    return (
        <Grid container justifyContent="space-between" alignItems="center" style={{ fontFamily: "Roboto, Helvetica", fontSize: 13, color: "#202124", paddingTop: 6, paddingBottom: 6,}}>
            <Grid item  xs={5} style={{ color: "#5f6368"}}>
                {props.property}
            </Grid>
            <Grid item xs={7}
                onClick={props.onClick}
                style={{ 
                    lineHeight: "20px", 
                    fontWeight: 500,
                    textOverflow: "ellipsis",
                    overflowX: "hidden",
                    cursor: props.onClick ? "pointer" : undefined,
                    color: props.onClick ? "#1967d2" : undefined, 
                }}
            >
                {props.value}
            </Grid>
        </Grid>
    )
}